var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 4h1v20H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 4h1v20H0zM22 4h1v20h-1z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 4h23v1H0zM3 7h1v17H3z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3 7h17v1H3z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19 7h1v17h-1zM11 7h1v17h-1z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M8.5 1.5h6v3h-6z"
})));
export default SvgGate;